import React, { useState, useEffect } from "react";
import "../../components/AddRegion/AddRegion.css";
import axios from "axios";

const AddRegion = ({tokenStorage, openAddProfile, setOpenAddProfile}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    region_id: "",
    region_name: "",
  
   
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}Adminpost/AddRegion`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
    
      // Optionally, reset the form
      setFormData({
        region_id: "",
        region_name: "",

      });
      tokenStorage();
      setOpenAddProfile (!openAddProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };


  return (
    <div className="container-fluid">
      <br />

      <div className="region">
        <div className="region-form" >
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Region Name*</td>
              <td>Region Code</td>
            </tr>

            <tr>
              <td>
                <input placeholder="Enter Please" name="region_name" value={formData.region_name} onChange={handleChange}/>
              </td>
              <td>
                <input placeholder="Enter Please"/>
              </td>
            
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addRegion-button">
          <button type="submit" onClick={handleSubmit}  style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white"}}>
              Add Region
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddRegion;
